import request from '@/utils/request'
import qs from 'qs'
/** ************************************************** 账号接口 ************************************************** */


// // 请求
// const request = (opt) => {
// 		opt = opt || {};
// 		opt.url = opt.url || '';
// 		opt.data = opt.data || null;
// 		opt.method = opt.method || 'GET';
// 		opt.headers = opt.header || {
// 			"Content-Type": "application/x-www-form-urlencoded",
// 			"Content-Type": "application/json"
// 		};
// 		// 对统一的请求进行处理

// 	    return http(opt)
// }

export function updVendorCodeByxq(params) {
    return request({
        url: '/v1/vendor/updVendorCodeByxq',
        method: 'get',
        params
    })

}
export function delVendorBrandLevel(data) {
    return request({
        url: '/v1/vendor/delVendorBrandLevel',
        method: 'post',
        data
    })

}
export function vendorCodeIsOrNo(params) {
    return request({
        url: '/v1/vendor/vendorCodeIsOrNo',
        method: 'get',
        params
    })

}
export function updVendorBrandLevel(data) {
    return request({
        url: '/v1/vendor/updVendorBrandLevel',
        method: 'post',
        data
    })

}
export function addVendorBrandLevel(data) {
    return request({
        url: '/v1/vendor/addVendorBrandLevel',
        method: 'post',
        data
    })

}
//供应商详情表格选择地区下拉数据
export function showRegionsBySearchName(data) {
    return request({
        url: '/v1/vendor/showRegionsBySearchName',
        method: 'post',
        data
    })

}
// 展示供应商详情中所对应的品牌OR等级OR服务区域数据
export function showVendorBrandLevels(data) {
    return request({
        url: '/v1/vendor/showVendorBrandLevels',
        method: 'post',
        data
    })

}
// 供应商详情表格选择品牌下拉数据
export function showBrandsBySearchName(data) {
    return request({
        url: '/v1/vendor/showBrandsBySearchName',
        method: 'post',
        data
    })

}

// 平台认证图片
export function upLoadAuthenticationPictures(data) {
    return request({
        url: '/v1/vendor/addVendorAuthenticationPictures/file',
        method: 'post',
        data
    })

}
// 施工服务导出供应商
export function exportVendorExcel(data) {
  return request({
    url: '/v1/vendor/exportExcel',
    method: 'post',
    data,
    responseType:"blob"
  })

}

// 施工服务导入供应商
export function importVendorExcel(data) {
    return request({
        url: '/v1/vendor/importExcel',
        method: 'post',
        data
    })

}
/**
 * 获取验证码图片
 */
export function getAuthCode() {
    return request({
        url: '/v1/account/loginValidateCode',
        method: 'get'
    })
}


export function getLargeAreaList() {
    return request({
        url: '/v1/api/getLargeAreaList',
        method: 'get'
        
    })
}

export function addSavetest(data) {
    return request({
        url: 'http://122.51.183.123/v/v1/api/addSavetest',
        method: 'post',
        data
    })
}

/**
 * 新增并保存账号
 * @param {data} 账号所有信息
 */
export function addAcount(data) {
    return request({
        url: '/v1/account/add',
        method: 'post',
        data
    })
}
/**
 * 检查验证码图片是否正确
 * @param {validateCode} 验证码参数
 */
export function verifyCode(data) {
    return request({
        url: '/v1/account/checkLoginValidateCode',
        method: 'get',
        data
    })
}

/**
 * 修改保存账号
 * @param {data} 修改账号所有参数
 */
export function updateAccount(data) {
    return request({
        url: '/v1/account/edit',
        method: 'post',
        data
    })
}
/**
 * 删除账号
 * @param { username } 手机号
 * @param { password } 密码
 */
export function deleteAcount(data) {
    return request({
        url: '/v1/account/remove',
        method: 'post',
        data
    })
}

/**
 * 根据id查询账号
 * @param {data} 账号id
 */
export function accountIDList(data) {
    return request({
        url: '/v1/account/getById',
        method: 'post',
        data
    })
}
/**
 * 账号列表复制
 * @param {data}
 */
export function listAll(data) {
    return request({
        url: '/v1/account/listAll',
        method: 'post',
        data
    })
}
/**
 * username-password登录
 * @param { username } 用户名
 * @param { password } 密码
 */
export function userNameLogin(data) {
    return request({
        url: '/v1/account/login',
        method: 'get',
        params: data
    })
}
export function loginByCode(data) {
  return request({
    url: '/v1/account/loginByCode',
    method: 'get',
    params: data
  })
}

/**
 * tel-password登录
 * @param { tel } 手机号
 * @param { password } 密码
 */
export function telLogin(data) {
    return request({
        url: '/v1/account/loginbytel',
        method: 'post',
        data
    })
}

/**
 * 密码重置
 * @param { id } id
 */
export function resetPassword(data) {
    return request({
        url: '/v1/account/restPassword',
        method: 'post',
        data
    })
}

/**
 * 修改密码
 * @param { id } id
 * @param { oldpassword } 旧密码
 * @param { password} 新密码
 */
export function updatePassword(data) {
    return request({
        url: '/v1/account/updatePassword',
        method: 'post',
        data
    })
}

/** ************************************************** 供应商类别接口 ************************************************** */

/**
 * 供应商类别-所有
 */
export function vendorcategoryList() {
    return request({
        url: '/v1/vendorcategory/list',
        method: 'post'

    })
}
/** ************************************************** 咨询消息接口 ************************************************** */

/**
 * 删除留言
 * @param {id} id
 */
export function deleteMessage(data) {
    return request({
        url: '/v1/customermessages/deleteById',
        method: 'post',
        data

    })
}

/**
 * 查看详情
 * @param {id} id
 */
export function showMessage(data) {
    return request({
        url: '/v1/customermessages/getById',
        method: 'post',
        data
    })
}

/**
 * admin查询咨询消息列表所有
 * @param {pageNum} pageNum
 * @param {pageSize} pageSize
 */
export function adminMessageAllList(data) {
    return request({
        url: '/v1/customermessages/listAllAdmin',
        method: 'post',
        data
    })
}

/**
 * admin查询咨询品牌列表所有
 * @param {pageNum} pageNum
 * @param {pageSize} pageSize
 */
export function selByBrand(data) {
    return request({
        url: '/v1/api/selByBrand',
        method: 'get',
        data
    })
}

/**
 * 查询咨询消息列表 自己的
 * @param {id} id
 * @param {pageNum} pageNum
 * @param {pageSize} pageSize
 */
export function listAllVendor(data) {
    return request({
        url: '/v1/customermessages/listAllVendor',
        method: 'post',
        data
    })
}

/** ************************************************** logo品牌接口 ************************************************** */

/**
 * 新增logo图片
 * @param {data} data
 */
export function addLogo(data) {
    return request({
        url: '/v1/brand/addBrand',
        method: 'post',
        data
    })
}

/**
 * 编辑保存logo图片
 * @param {data} data
 */
export function editorLogo(data) {
    return request({
        url: '/v1/brand/edit/file',
        method: 'post',
        headers: {
            "Content-Type": "multipart/form-data",
            'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
        },
        data
    })
}
// export function editorLogo(formData) {
//     let config = {
//         headers: {
//           // "Content-Type": "multipart/form-data",
//           'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
//         //   Authorization: "Bearer " + getToken()
//         }
//     };
//     return request("/v1/brand/edit", formData, config)
// }

/**
 * 删除LOGO
 * @param {data} data
 */
export function deleteLogo(data) {
    return request({
        url: '/v1/brand/remove',
        method: 'post',
        data
    })
}

/**
 * upload Logo
 * @param {data} data
 */
export function uploadLogo(data) {
    return request({
        url: '/v1/brand/uploadPicture',
        method: 'post',
        data
    })
}

/**
 * 根据id查Logo品牌
 * @param {data} data
 */
export function queryLogo(data) {
    return request({
        url: '/v1/brand/getById',
        method: 'post',
        data
    })
}

/**
 * 查询所有品牌
 * @param {data} data
 */
export function queryLogoAll(data) {
    return request({
        url: '/v1/brand/listAll',
        method: 'post',
        data
    })
}

/**
 * 查询所有品牌
 * @param {data} data
 */
export function queryLogoAll1(params) {
    return request({
        url: '/v1/api/selByBrand',
        method: 'get',
        params
    })
}

/**
 * 回显账号
 * @param { id } id
 */
export function showUsername(params) {
    return request({
        url: '/v1/account/reusername',
        method: 'post',
        params
    })
}

/**
 * 回显账号
 * @param
 */
export function updateAccountStatus(params) {
    return request({
        url: '/v1/account/updStatus',
        method: 'post',
        params
    })
}


/**
 * 根据id查询施工队
 * @param {data} data
 */
export function queryIdVendor(params) {
    return request({
        url: '/v1/vendor/getById',
        method: 'post',
        params
    })
}

/**
 * 查询资质
 * @param {data} data
 */
export function queryQualification(params) {
    return request({
        url: '/v1/api/selByQualification',
        method: 'get',
        params
    })
}

export function imgQuery(params) {
    return request({
        url: '/v1/vendor/selectImgById',
        method: 'post',
        params
    })
}

/** ************************************************** 市接口 ************************************************** */

/**
 * 添加保存city
 * @param {data} data
 */
export function addCity(data) {
    return request({
        url: '/v1/city/add',
        method: 'post',
        data
    })
}

/**
 * 删除 品牌图片
 * @param {data} data
 */
export function brandremove(data) {
    return request({
        url: '/v1/brand/remove',
        method: 'post',
        data
    })
}


/**
 * 编辑保存city
 * @param {data} data
 */
export function updateCity(data) {
    return request({
        url: '/v1/city/edit',
        method: 'post',
        data
    })
}

/**
 * list city
 * @param {data} data
 */
export function cityList(data) {
    return request({
        url: '/v1/city/list',
        method: 'post',
        data
    })
}

/**
 * remove List
 * @param {data} data
 */
export function deleteCity(data) {
    return request({
        url: '/v1/city/remove',
        method: 'post',
        data
    })
}

/**
 * 查询城市根据code
 * @param {data} data
 */
export function queryCity(data) {
    return request({
        url: '/v1/city/selectByregionCode',
        method: 'post',
        data
    })
}

/** ************************************************** 施工对接口 ************************************************** */

/**
 * 轮播图上传
 * @param {data} data
 */
export function uploadVendorBanner(data) {
    return request({
        url: '/v1/vendor/addBanners',
        method: 'post',
        data
    })
}

/**
 * 资质图上传
 * @param {data} data
 */
export function uploadQualifications(data) {
    return request({
        url: '/v1/vendor/addQualifications',
        method: 'post',
        data
    })
}

/**
 * 新增施工队
 * @param {data} data
 */
export function addVendor(data) {
    return request({
        url: '/v1/vendor/addVendor/file',
        method: 'post',
        data
    })
}

/**
 * 修改施工队
 * @param {data} data
 */
export function updateVendor(data) {
    return request({
        url: '/v1/vendor/edit/file',
        method: 'post',
        data
    })
}

/**
 * 根据id查询施工队
 * @param {data} data
 */
export function queryVendor(data) {
    return request({
        url: '/v1/vendor/getById',
        method: 'post',
        data
    })
}

/**
 * 删除施工队
 * @param {data} data
 */
export function deleteVendor(data) {
    return request({
        url: '/v1/vendor/getById',
        method: 'post',
        data
    })
}

/**
 * 根据所用供应商的编码code
 * @param {data} data
 */
export function queryCodeVendorList(data) {
    return request({
        url: '/v1/vendor/selectAllCode',
        method: 'post',
        data
    })
}

/**
 * 查询施工队列表
 * @param {data} data
 */
export function queryVendorList(data) {
    return request({
        url: '/v1/vendor/showList',
        method: 'post',
        data
    })
}

/**
 * 修改施工队state
 * @param {data} data
 */
export function updateVendorState(data) {
    return request({
        url: '/v1/vendor/upaState',
        method: 'post',
        data
    })
}

/** ************************************************** 服务案例接口 ************************************************** */

/**
 * 首焦图片上传
 * @param {data} data
 */
export function uploadCasePicture(data) {
    return request({
        url: '/v1/servicecase/addCasePicture',
        method: 'post',
        data
    })
}

/**
 * 大堂图上传
 * @param {data} data
 */
export function uploadHallPictures(data) {
    return request({
        url: '/v1/servicecase/addHallPictures',
        method: 'post',
        data
    })
}

/**
 * 外观图上传
 * @param {data} data
 */
export function uploadOtherPictures(data) {
    return request({
        url: '/v1/servicecase/addOverviewPictures',
        method: 'post',
        data
    })
}

/**
 * 客房图上传
 * @param {data} data
 */
export function uploadRoomPictures(data) {
    return request({
        url: '/v1/servicecase/addRoomPictures',
        method: 'post',
        data
    })
}

/**
 * 卫生间图上传
 * @param {data} data
 */
export function uploadWashroomPictures(data) {
    return request({
        url: '/v1/servicecase/addWashroomPictures',
        method: 'post',
        data
    })
}

/**
 * 新增保存服务案例
 * @param {data} data
 */
export function addServicecase(data) {
    return request({
        url: '/v1/servicecase/addServicecase/file',
        method: 'post',
        data
    })
}

/**
 * 改变保存服务案例
 * @param {data} data
 */
export function updateServicecase(data) {
    return request({
        url: '/v1/servicecase/edit/file',
        method: 'post',
        data
    })
}
/**
 * 根据id查询服务案例
 * @param {data} data
 */
export function selByQualification(data) {
    return request({
        url: '/v1/api/selByQualification',
        method: 'get',
        data
    })
}

/**
 * 根据id查询服务案例
 * @param {data} data
 */
export function queryIdServicecase(data) {
    return request({
        url: '/v1/servicecase/getServicecaseById',
        method: 'post',
        data
    })
}

/**
 * 查询所有服务案例列表
 * @param {data} data
 */
export function queryServicecaseList(data) {
    return request({
        url: '/v1/servicecase/list',
        method: 'post',
        data
    })
}

/**
 * 删除服务案例
 * @param {data} data
 */
export function deleteServicecase(data) {
    return request({
        url: '/v1/servicecase/remove',
        method: 'post',
        data
    })
}
/**
 * 删除供应商下架
 * @param {data} data
 */
export function vendoremove(data) {
    return request({
        url: '/v1/vendor/remove',
        method: 'post',
        data
    })
}

/**
 * 供应商搜索 列表
 * @param {data} data
 */
export function vshowVendor(data) {
    return request({
        url: '/v1/vendor/showVendor',
        method: 'post',
        data
    })
}


/**
 * 修改服务案例状态
 * @param {data} data
 */
export function upaServicecase(data) {
    return request({
        url: '/v1/servicecase/upaState',
        method: 'post',
        data
    })
}

/** ************************************************** 权限接口 ************************************************** */

/**
 * 权限展示
 */
export function showPermission() {
    return request({
        url: '/v1/permission/PermissionList',
        method: 'post'
    })
}
/** ************************************************** 角色接口 ************************************************** */

/**
 * 账号添加角色
 * @param {data} data
 */
export function addRole(data) {
    return request({
        url: '/v1/assetuserrole/addRole',
        method: 'post',
        data
    })
}

/** ************************************************** 省接口 ************************************************** */

/**
 * 省接口添加
 * @param {data} data
 */
export function addRegion(data) {
    return request({
        url: '/v1/region/add',
        method: 'post',
        data
    })
}
/**
 * 查找所有省份
 * @param {data} data
 */
export function selectadrss(data) {
    return request({
        url: '/v1/region/listAll',
        method: 'post',
        data
    })
}


/**
 * 查找所有城市
 * @param {data} data
 */
export function selectByregionCode(data) {
    return request({
        url: '/v1/city/selectByregionCode',
        method: 'post',
        data
    })
}


/**
 * 生接口编辑保存
 * @param {data} data
 */
export function updateRegion(data) {
    return request({
        url: '/v1/region/edit',
        method: 'post',
        data
    })
}




/**
 * 省接口列表查询
 * @param {data} data
 */
export function queryRegionList(data) {
    return request({
        url: '/v1/region/listAll',
        method: 'post',
        data
    })
}






